import "./ProcessingProgress.scss";
import { cn } from "tailwind-variants";

const FIRST_MESSAGE = "Uploading file";

export default function ProcessingProgress({ message = FIRST_MESSAGE, ...restProps }) {
  return (
    <div {...restProps} className={cn("processing-progress scope-d7e87e75", restProps.className)}>
      {message}
    </div>
  );
}
